module.exports = __webpack_public_path__ + "img/chp-habit.95a2b5e6.png";